import { Directive, ElementRef, HostListener, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
    selector: '[tfStickyToHeader]'
})
export class TfStickyToHeaderDirective implements OnInit {

    handlerScrolling: HTMLElement = null;
    @Input() stickyOffset: number = 0;

    @HostListener('window:scroll', [])
    handleScroll() {

        const data = this.handlerScrolling.getBoundingClientRect();
        if (window.scrollY >= this.stickyOffset) {
            this.renderer.addClass(this.elementRef.nativeElement, 'tf-sticky');
            this.renderer.setStyle(this.elementRef.nativeElement, 'top', data.bottom + 'px');
        } else {
            this.reset();
        }
    }

    constructor(
        private renderer: Renderer2,
        private elementRef: ElementRef
    ) {

    }

    ngOnInit() {
        this.handlerScrolling = document.querySelector('header');
    }

    reset() {
        this.renderer.removeClass(this.elementRef.nativeElement, 'tf-sticky');
        this.renderer.setStyle(this.elementRef.nativeElement, 'top', '');
    }

}
